import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useFetchPeOrderDetailQuery } from 'rtkQuery/sharespro/queries/peService';

import PeCompanyDataView from 'presentation/components/modules/pe/shared/detail/PeCompanyDataView';

const PeP2POrderDetailPage: FC = () => {
  const { id } = useParams();
  const { isFetching, data, refetch, error } = useFetchPeOrderDetailQuery({
    id: +(id as string),
  });

  return (
    <PeCompanyDataView
    assetId={+(id as string)}
      isFetching={isFetching}
      data={data?.company}
      refetch={() => {
        refetch();
      }}
      error={error}
    />
  );
};

export default PeP2POrderDetailPage;
